<template>
  <div class="app">
    <div v-if="!$route.name" class="no-route-background">
      <img src="@/assets/logo-red.png" alt=""/>
    </div>
    <Header v-else-if="$route.name && !$route.meta.noHeader"/>
    <router-view/>
    <Spin v-if="$store.state.loadingText"
          fix size="large">{{$store.state.loadingText}}</Spin>
  </div>
</template>

<script>
    import Header from '@/views/Header';
    export default {
        components: {
            Header
        }
    }
</script>

<style scoped>
  .no-route-background {
    line-height: 90vh;
    text-align: center;
    vertical-align: middle;
  }
</style>
